module.exports = __webpack_public_path__ + "static/img/ic_subway_on@2x.4b82411.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_subway_on@2x.png
// module id = VTov
// module chunks = 1